import { render } from "./VoiceRecognition.vue?vue&type=template&id=2da0777a&scoped=true"
import script from "./VoiceRecognition.vue?vue&type=script&lang=js"
export * from "./VoiceRecognition.vue?vue&type=script&lang=js"

import "./VoiceRecognition.vue?vue&type=style&index=0&id=2da0777a&scoped=true&lang=css"

import exportComponent from "D:\\WORKSPACE\\Netbeans\\lz06\\2022xiongmao\\xiongmao\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da0777a"]])

export default __exports__